
// Funciones auxiliares para conversión de coordenadas a azulejos (Tiles) OSM
const lon2tile = (lon, zoom) => {
    return (Math.floor((lon + 180) / 360 * Math.pow(2, zoom)));
};

const lat2tile = (lat, zoom) => {
    return (Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, zoom)));
};

// Cálculo preciso de píxeles para centrado exacto
const project = (lat, lng, zoom) => {
    const R = 6378137;
    const maxLat = 85.0511287798;
    const d = Math.PI / 180;
    const max = maxLat;
    const latRad = Math.max(Math.min(max, lat), -max) * d;
    const scale = 256 * Math.pow(2, zoom);

    const x = ((lng + 180) / 360) * scale;
    const y = ((1 - Math.log(Math.tan(latRad) + 1 / Math.cos(latRad)) / Math.PI) / 2) * scale;
    return { x, y };
};

export const generateMapImage = async (latitude, longitude) => {
    console.log('=== GENERANDO IMAGEN DE MAPA OSM (CLIENT-SIDE) ===');
    console.log('Coordenadas:', latitude, longitude);

    const mapWidth = 800;
    const mapHeight = 500;
    const zoom = 16; // Zoom óptimo para ver calles y detalles

    // Crear canvas
    const canvas = document.createElement('canvas');
    canvas.width = mapWidth;
    canvas.height = mapHeight;
    const ctx = canvas.getContext('2d');

    // Fondo gris mientras carga
    ctx.fillStyle = '#e9ecef';
    ctx.fillRect(0, 0, mapWidth, mapHeight);

    try {
        // 1. Calcular coordenadas centrales en píxeles del mundo
        const center = project(latitude, longitude, zoom);

        // 2. Calcular límites del viewport del canvas en el mundo
        const startX = center.x - mapWidth / 2;
        const startY = center.y - mapHeight / 2;
        const endX = startX + mapWidth;
        const endY = startY + mapHeight;

        // 3. Determinar qué tiles (baldosas) se necesitan
        const startTileX = Math.floor(startX / 256);
        const startTileY = Math.floor(startY / 256);
        const endTileX = Math.floor(endX / 256);
        const endTileY = Math.floor(endY / 256);

        // 4. Descargar y dibujar tiles
        const tilesToLoad = [];
        for (let tx = startTileX; tx <= endTileX; tx++) {
            for (let ty = startTileY; ty <= endTileY; ty++) {
                tilesToLoad.push({ tx, ty });
            }
        }

        console.log(`Cargando ${tilesToLoad.length} tiles de OSM...`);

        const promises = tilesToLoad.map(tile => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = "anonymous"; // Importante para OSM
                // Servidor A, B o C
                const subdomain = ['a', 'b', 'c'][Math.floor(Math.random() * 3)];
                img.src = `https://${subdomain}.tile.openstreetmap.org/${zoom}/${tile.tx}/${tile.ty}.png`;

                img.onload = () => resolve({ img, tile });
                img.onerror = () => {
                    console.warn(`Error cargando tile ${tile.tx}/${tile.ty}`);
                    resolve(null); // Resolvemos null para no romper Promise.all
                };
            });
        });

        const loadedTiles = await Promise.all(promises);

        // 5. Dibujar cada tile en su posición correcta
        loadedTiles.forEach(item => {
            if (item) {
                const { img, tile } = item;
                // Posición del tile en el mundo
                const tileX = tile.tx * 256;
                const tileY = tile.ty * 256;

                // Posición relativa en el canvas
                const drawX = tileX - startX;
                const drawY = tileY - startY;

                ctx.drawImage(img, drawX, drawY);
            }
        });

        // 6. Dibujar Marcador Estilo "Google Maps"
        const mx = mapWidth / 2;
        const my = mapHeight / 2;

        // Sombra
        ctx.fillStyle = 'rgba(0,0,0,0.3)';
        ctx.beginPath();
        ctx.ellipse(mx, my, 8, 4, 0, 0, Math.PI * 2);
        ctx.fill();

        // Pin Rojo
        ctx.fillStyle = '#ea4335';
        ctx.beginPath();
        // Forma de gota invertida simple
        ctx.moveTo(mx, my);
        ctx.bezierCurveTo(mx - 10, my - 20, mx - 20, my - 30, mx - 20, my - 45);
        ctx.arc(mx, my - 45, 20, Math.PI, 0); // Semicírculo superior
        ctx.bezierCurveTo(mx + 20, my - 30, mx + 10, my - 20, mx, my);
        ctx.fill();

        // Círculo blanco interior
        ctx.fillStyle = '#fff';
        ctx.beginPath();
        ctx.arc(mx, my - 45, 8, 0, Math.PI * 2);
        ctx.fill();

        // 7. Copyright / Atribución
        ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
        ctx.fillRect(mapWidth - 140, mapHeight - 20, 140, 20);
        ctx.fillStyle = '#333';
        ctx.font = '10px Arial';
        ctx.textAlign = 'right';
        ctx.fillText('© OpenStreetMap contributors', mapWidth - 5, mapHeight - 5);

        // 8. Borde decorativo
        ctx.strokeStyle = '#28a745';
        ctx.lineWidth = 4;
        ctx.strokeRect(0, 0, mapWidth, mapHeight);

        console.log('✓ Mapa OSM generado exitosamente');
        return canvas.toDataURL('image/png');

    } catch (error) {
        console.error('Error generando mosaico OSM:', error);
        // Fallback simple si algo falla
        return null;
    }
};
